export const createOrder = (order) => {
  // Return action
  return {
    // Unique identifier
    type: 'CREATE_ORDER',
    // Payload
    order: order
  }
};

export const updateOrder = (orde) => {
  // Return action
  return {
    // Unique identifier
    type: 'UPDATE_ORDER',
	order: orde,
  }
};

export const fetchOrderRecords = (orders) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_ORDERS',
	orders: orders
	//orders: normalize(orders, orderSchema)
  }
};

export const setCustomerConfig = (customer_config) => {
  // Return action
  return {
    // Unique identifier
    type: 'SET_CUSTOMERCONFIG',
	customer_config: customer_config
  }
};
export const fetchTmxMatch = (id, tmx_match) => {
	return {
    type: 'GET_TMX_MATCH',
	id_order: id,
	tmx_match: tmx_match
  }
};